var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../../node_modules/htmlhint-loader/index.js??ref--0!./c-categories.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0ddf5030!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../../node_modules/htmlhint-loader/index.js??ref--0!./c-categories.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/base/category/c-categories.vue
// module id = 605
// module chunks = 1